import type { FlexProps } from '@chakra-ui/react';
import { Flex, chakra } from '@chakra-ui/react';
import React from 'react';

import { useIsSticky } from 'toolkit/hooks/useIsSticky';

type Props = FlexProps & {
  children: React.ReactNode;
  className?: string;
  showShadow?: boolean;
};

export const ACTION_BAR_HEIGHT_DESKTOP = 24 + 32 + 12;
export const ACTION_BAR_HEIGHT_MOBILE = 24 + 32 + 24;

const ActionBar = ({ children, className, showShadow, ...flexProps }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const isSticky = useIsSticky(ref, 5);

  if (!React.Children.toArray(children).filter(Boolean).length) {
    return null;
  }

  return (
    <Flex
      className={ className }
      // 保留背景色（吸顶时需要）
      backgroundColor="bg.primary"
      // 统一 padding 为 12px（p={3}）
      p={ 3 }
      justifyContent="space-between"
      // 移动端不再使用 100vw，避免超出布局；统一用容器宽度
      width={{ base: '100%', lg: 'unset' }}
      // 移动端不需要吸顶，PC 端保持 sticky
      position={{ base: 'static', lg: 'sticky' }}
      top={{ base: 'unset', lg: 0 }}
      transitionProperty="top,box-shadow,background-color,color"
      transitionDuration="normal"
      zIndex={{ base: 'unset', lg: 'docked' }}
      boxShadow={{
        base: 'none',
        lg: isSticky && showShadow ? 'action_bar' : 'none',
      }}
      { ...flexProps }
      // 去掉所有 margin（避免布局偏移）- 放在 flexProps 之后确保不被覆盖
      mt={ 0 }
      mx={ 0 }
      ref={ ref }
    >
      { children }
    </Flex>
  );
};

export default chakra(ActionBar);
